import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPhysicianDuties(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/report-limit-by-institution', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
